import { createContext, useContext } from 'react';
import type { Page } from '../types';

interface NavigationValue {
  /** App's `requestPageAccess`, so the usual permission / PIN checks still apply. */
  navigate: (page: Page) => void;
  /** The page the user was on before the current one (null on first load). */
  previousPage: Page | null;
}

/**
 * Lets deeply nested components (the POS header's notification bell, "Back to POS" buttons)
 * switch pages without threading an onNavigate prop through every parent.
 */
const NavigationContext = createContext<NavigationValue | null>(null);

export const NavigationProvider = NavigationContext.Provider;

export function useNavigateToPage(): ((page: Page) => void) | null {
  return useContext(NavigationContext)?.navigate ?? null;
}

export function usePreviousPage(): Page | null {
  return useContext(NavigationContext)?.previousPage ?? null;
}
